var map = {
	"./logo-MP-home.svg": 4688,
	"./logo-PARC.svg": 7416,
	"./logo-billing.svg": 6669,
	"./logo-carshare.svg": 2660,
	"./logo-commercial.svg": 5905,
	"./logo-compete2020-black.svg": 6925,
	"./logo-consilium.svg": 769,
	"./logo-facilities.svg": 8485,
	"./logo-meeting.svg": 891,
	"./logo-perceptum.svg": 4559
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2618;